import { useId } from 'preact/hooks'
import { Activity, Inbox, Reply, type LucideIcon } from 'lucide-preact'
import { useCompany } from '@/hooks/useCompany'
import { SUGGESTIONS_NOTE, domainSuggestions, type DomainSuggestion } from '@/utils/sendingDomainStatus'
import { BlockHeading } from './DomainPageParts'

const ICONS: Record<DomainSuggestion['kind'], LucideIcon> = { dmarc: Inbox, postmaster: Activity, replyTo: Reply }

/** Optional deliverability habits, shown beside the warm-up and never blocking it. */
export function DomainSuggestions({ domain }: { domain: string }) {
  const headingId = useId()
  const { company } = useCompany()

  return (
    <section aria-labelledby={headingId} className="space-y-4">
      <div className="flex flex-wrap items-baseline gap-3">
        <BlockHeading id={headingId}>Suggestions</BlockHeading>
        <span className="text-xs text-slate-500 dark:text-slate-400">{SUGGESTIONS_NOTE}</span>
      </div>
      <ul className="space-y-4">
        {domainSuggestions(domain, company?.Name || null).map(({ kind, title, text }) => {
          const Icon = ICONS[kind]
          return (
            <li key={kind} className="flex items-start gap-3">
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" aria-hidden="true" />
              <div>
                <p className="text-sm font-medium text-slate-800 dark:text-slate-100">{title}</p>
                <p className="max-w-prose text-[13px] text-slate-600 dark:text-slate-400">{text}</p>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
